// data.ts

export interface Training {
    [key: string]: {
      id: string;
      name: string;
    };
  }
  
  export interface Condition {
    [key: string]: {
      id: string;
      name: string;
    };
  }
  
  export interface Matricule {
    [key: string]: {
      id: string;
      name: string;
    };
  }

  export interface Status {
    [key: string]: {
      id: string;
      name: string;
    };
  }

  export interface Cycle {
    [key: string]: {
      id: string;
      name: string;
    };
  }

  export interface Actions {
    [key: string]: {
      id: number;
      name: string;
      button: string,
      method: string
    };
  }

  export interface statusPayroll {
    [key: string]: {
      id: number;
      name: string;
      class: string;
    };
  }
  
  const training: Training = {
    "F": { "id": "F", "name": "Federación"},
    "U": { "id": "U", "name": "Univesidad"}
  };
  
  const condition: Condition = {
    "P": { "id": "P", "name": "Pregrado"},
    "E": { "id": "E", "name": "Egresado"},
    //"T": { "id": "T", "name": "Diplomado"},
    "M": { "id": "M", "name": "Maestria"},
    "D": { "id": "D", "name": "Doctorado"}
  };
  
  const matricule: Matricule = {
    "S": { "id": "S", "name": "Semestral"},
    "A": { "id": "A", "name": "Anual"}
  };

  const cycle: Cycle = {
    "1": { "id": "1", "name": "1er ciclo"},
    "2": { "id": "2", "name": "2do ciclo"},
    "3": { "id": "3", "name": "3er ciclo"},
    "4": { "id": "4", "name": "4to ciclo"},
    "5": { "id": "5", "name": "5to ciclo"},
    "6": { "id": "6", "name": "6to ciclo"},
    "7": { "id": "7", "name": "7mo ciclo"},
    "8": { "id": "8", "name": "8vo ciclo"},
    "9": { "id": "9", "name": "9no ciclo"},
    "10": { "id": "10", "name": "10mo ciclo"},
    "11": { "id": "11", "name": "11vo ciclo"}
  }

  const status: Status = {
    "Borrador": { "id": "0", "name": "light"},
    "Aprobado": { "id": "1", "name": "success"},
    "Anulado": { "id": "2", "name": "danger"},
    "Revision": { "id": "3", "name": "warning"},
    "Subsanar": { "id": "4", "name": "info"},
    "Rechazado": { "id": "4", "name": "danger"}
  };

  const actions: Actions = {
    0: { "id": 0, "name": "Eliminar", "button": "", "method": "delete"},
    1: { "id": 1, "name": "Registrar", "button": "Guardar", "method": "save"},
    2: { "id": 2, "name": "Editar", "button": "Actualizar", "method": "update"},
    3: { "id": 3, "name": "Visualizar", "button": "", "method": "show"},
  }

  const status_payroll: statusPayroll = {
    0: { "id": 0, "name": "Borrador", "class": "light"},
    1: { "id": 1, "name": "Aprobado", "class": "success"},
    2: { "id": 2, "name": "Archivado", "class": "danger"},
    3: { "id": 3, "name": "Revisión", "class": "warning"},
    4: { "id": 4, "name": "Observado", "class": "info"},
  }
  
  export { training, condition, matricule, status, actions, status_payroll, cycle };  